import React from 'react'
import { Table } from 'antd'

import commontStyles from '../../../../Utils/Common.less'
import type { onboardingPartnershipExpandViewInterface } from '../../../../Types/Client/OnboardingClients/OnBoardingPartnership'

const PartnershipExpandView = (
    props: onboardingPartnershipExpandViewInterface
): React.ReactElement => {
    const { PartnershipData } = props

    const columns = [
        {
            title: 'Name',
            dataIndex: 'contactName',
        },
        {
            title: 'Contact No',
            dataIndex: 'mobileNumber',
        },
        {
            title: 'Email',
            dataIndex: 'emailAddress',
        },
    ]

    const dataSource = [
        {
            key: '1',
            mobileNumber: PartnershipData.mobileNumber,
            emailAddress: PartnershipData.emailAddress,
            contactName: PartnershipData.contactName,
        },
    ]

    return (
        <div className={commontStyles.expandCard}>
            <Table
                columns={columns}
                dataSource={dataSource}
                pagination={false}
            />
        </div>
    )
}

export default PartnershipExpandView
